module.exports = __webpack_public_path__ + "img/07-1.2bdf90e7.png";